import { createSelector } from 'reselect'
import sessionTypes from 'helpers/enums/sessionTypes'

const getSlideId = (state, props) => props.session.session_uid + '_' + props.slide.slideId
const getStudentViewData = state => state.student

const timerDisabledSessionTypes = [
	sessionTypes.HOMEWORK,
	sessionTypes.PREVIEW,
	sessionTypes.EMBED,
]

export default createSelector(
	[getStudentViewData, getSlideId],
	(student, slideId) => {
		const isDisabled = timerDisabledSessionTypes.includes(student.sessionType)
		const slide_data = student.slides[slideId]
		if (slide_data && !isDisabled) {
			return slide_data.timer
		} else {
			return null
		}
	}
)
